
import {aiApi} from './ai'

export const verifySocialAccountApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    
    verifySocialAccount: builder.mutation({
      query: (accountId) => ({
        url: `/social/accounts/${accountId}/verify`,
        method: 'POST',
      }),
      invalidatesTags: ['SocialAccount'],
    }),

  }),
  overrideExisting: false,
})

export const { useVerifySocialAccountMutation } = verifySocialAccountApi